module.exports = __webpack_public_path__ + "static/media/79d731fe-d29c-48b7-9312-f503ee13216f.7b70f153.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/1274157/79d731fe-d29c-48b7-9312-f503ee13216f.ttf
// module id = 1670
// module chunks = 2